export default "__VITE_ASSET__6eb2229f__"